module.exports = __webpack_public_path__ + "images/392ab9dbff73606591517b53be1a4fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ayse_thumb.jpg
// module id = 164
// module chunks = 24